import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const SpaceIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 36 36',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path d="M15 30v-9h6v9h7.5V18H33L18 4.5 3 18h4.5v12zm0 0"></path>
  </SvgIcon>
);

export default SpaceIcon;
